import useSelectedEvent from '@Hooks/useSelectedEvent'
import { entitySauce } from '@State'

import { LeadScanQuestion } from '../interfaces'
const collectionName = 'leadScanQuestion'

interface UseLeadScanQuestionsProps {
  sponsorId: string
}

export default function useLeadScanQuestions({ sponsorId }: UseLeadScanQuestionsProps) {
  const { selectedEvent: { id: eventId } } = useSelectedEvent()

  const { data: { data: leadScanQuestions }, isLoading } = entitySauce.useGet([collectionName, { eventId, sponsorId }]) as { data: { data: LeadScanQuestion[] }, isLoading: boolean }

  const [create, { isLoading: isCreating }] = entitySauce.usePost([collectionName, { eventId, sponsorId }])

  const [update, { isLoading: isUpdating }] = entitySauce.usePatch([collectionName, { eventId, sponsorId }])

  const [remove, { isLoading: isRemoving }] = entitySauce.useRemove([collectionName, { eventId, sponsorId }])

  return {
    leadScanQuestions,
    query: {
      isLoading
    },
    create: {
      mutate: create,
      isLoading: isCreating
    },
    update: {
      mutate: update,
      isLoading: isUpdating
    },
    remove: {
      mutate: remove,
      isLoading: isRemoving
    }
  }
}
